import React from "react";
import { useNavbarContext } from "hooks/useContextAll";
import NavbarLinksList from "./NavbarLinksList";
import NavbarAccessoriesList from "./NavbarAccessoriesList";

const Navbar = () => {
    const navbarContext = useNavbarContext();

    return (
        <nav className="navbar">
            <div
                className={`navbar-lists-wrapper ${
                    navbarContext.navbarToggle ? "active" : ""
                }`}
            >
                <NavbarLinksList />
                <NavbarAccessoriesList />
            </div>
        </nav>
    );
};

export default Navbar;
